<div class="p-supportmenu absolute end-0 top-0 lg:me-6 lg:mt-2">
  <div class="lg:hidden p-supportmenu-logo">
    @if (customLogo) {
      <img [src]="customLogo" class="logo" alt="">
    } @else {
      <a routerLink="/dashboard"><img src="/assets/img/logo_full.svg" class="logo" [alt]="'l_tagline' | i18n"></a>
    }
  </div>

  <!-- bof DARK MODE -->
  @if (!isSubaccount) {
  <p-button icon="pi pi-shopping-cart" [label]="'button_add_plan' | i18n" routerLink="/myaccount/upgrade" styleClass="pi-button pi-button-purchase hidden lg:inline-block me-4"></p-button>
  }
  <p-button icon="pi pi-desktop" [label]="'display_settings' | i18n" (click)="op.toggle($event)" styleClass="pi-button hidden lg:inline-block"></p-button>
  <p-popover #op>
    <ng-template pTemplate="content">

      <h5 class="mb-2">{{'display_font_size' | i18n}}</h5>
      <div class="p-buttonset mb-2">
        <button pButton [ngClass]="{'w-[6rem]': true,'active': currentDisplayFont === 'small'}" (click)="setDisplayFont('small')" type="button" [label]="'display_small' | i18n"></button>
        <button pButton [ngClass]="{'w-[6rem]': true,'active': currentDisplayFont === 'medium'}" (click)="setDisplayFont('medium')" type="button" [label]="'display_medium' | i18n"></button>
        <button pButton [ngClass]="{'w-[6rem]': true,'active': currentDisplayFont === 'large'}" (click)="setDisplayFont('large')" type="button" [label]="'display_large' | i18n"></button>
      </div>
      <h5 class="mb-2">{{'display_layout_mode' | i18n}}</h5>
      <div class="p-buttonset">
        <button pButton [ngClass]="{'w-[6rem]': true,'active': currentDisplayTheme === 'light'}" type="button" (click)="setDisplayTheme('light')" [label]="'display_light_mode' | i18n"></button>
        <button pButton [ngClass]="{'w-[6rem]': true,'active': currentDisplayTheme === 'auto'}" type="button" (click)="setDisplayTheme('auto')" [label]="'display_auto_mode' | i18n"></button>
        <button pButton [ngClass]="{'w-[6rem]': true,'active': currentDisplayTheme === 'dark'}" type="button" (click)="setDisplayTheme('dark')" [label]="'display_dark_mode' | i18n"></button>
      </div>

    </ng-template>
  </p-popover>
  <!-- eof DARK MODE -->

  <p-menubar [model]="headerMenuItems"></p-menubar>
  <div id='tawk_5b9b8524c9abba57967788e4'></div>
</div>
